export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', ];

export const formatBytes = (bytes)=> {
  if (bytes === 0) return '0 Bytes';
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = (bytes / Math.pow(1024, i)).toFixed(2);
  return `${value} ${sizes[i]}`;
}


export const transformResourcesToTreeData = (resources) => {
    const treeData = [{
      title: 'Home', // Title of the home directory node
      key: '', // Empty key to represent the root
      children: [],
      isLeaf: false // It is not a leaf node as it will have children
    }];
    const folderMap = {};
    const prefix = 'users/';

    resources.forEach((resource) => {
      const fullParts = resource.path.split('/');
      const partsIndex = fullParts.indexOf(prefix.slice(0, -1));
      const pathParts = partsIndex !== -1 ? fullParts.slice(partsIndex + 2) : fullParts.slice(1); // Skip the 'users/<uuid>/' part
      let currentLevel = treeData;
      let currentPath = '';

      pathParts.forEach((part, index) => {
        currentPath += part + '/';
        // Check if the current path part is not the last part, which indicates a folder
        if (!folderMap[currentPath] && index < pathParts.length - 1) {
          const newFolder = {
            title: part,
            key: currentPath,
            children: [],
            isLeaf: false,  // Ensure that this is always treated as a folder
          };
          currentLevel.push(newFolder);
          folderMap[currentPath] = newFolder;
        }
        currentLevel = folderMap[currentPath]?.children || [];
      });
    });

    return treeData;
};
